Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.Utils = {

    getTitle: function (text) {
        var titleContainer = document.createElement('div');
        var title = document.createElement('h1');
        title.innerHTML = Monet.I18n.getResourcesByKey(text);
        titleContainer.className = 'MonetUIFormSectionTitle';

        titleContainer.appendChild(title);

        return titleContainer;
    },

    getPreview: function (QTE_LINHAS, callback) {

        var request = new Monet.Ajax();

        request.url = '/TextFileUpload/Preview/' + App.Forms.DataImport.uploadFile.id + '/' + QTE_LINHAS;
        request.method = 'GET';
        request.success = function (data) {
            if (data) {
                callback(data.lines);
            } else {
                callback([Monet.I18n.getResourcesByKey('DataImport.cannotgetPreviewData')]);
            }
        }.bind(this);

        request.send();
    },


    showErrorMessage: function (error) {
        error = typeof error !== 'object' ? JSON.parse(error) : error;
        App.Objects.DataImport.createAndUpdateErrorHandler(error, null, "DataImport");
    },

    clearErrorMessage: function () {
        var error = document.querySelector('#DataImport .monetInlineAlerContainer');
        error.innerHTML = '';
    },

    getFormatterOptionsByType: function (type) {
        var locale = Monet.I18n.locale,
            inverseFormat = "##" + locale.decimalSymbol + "###" + locale.digitalGrouping  + "##",
            userNumberFormat = "##" + locale.digitalGrouping + "###" + locale.decimalSymbol  + "##",
            userDateFormat = locale.dateFormat,
            userDateTimeFormat = locale.dateFormat + " " + locale.timeFormat,
            templateValue = App.Forms.DataImport.CSVConfigurations.value,
            advancedConfigs = (templateValue ? templateValue.configuration : {}),

            numberFormatters = {
                defaultValue: advancedConfigs.numberFormat || userNumberFormat,
                fieldDomains: [{
                        description: inverseFormat,
                        value: inverseFormat
                    },
                    {
                        description: userNumberFormat,
                        value: userNumberFormat
                    }
                ]
            };

        var options = {
            'DATE': {
                defaultValue: advancedConfigs.dateFormat || userDateFormat,
                fieldDomains: [{
                        description: "dd/MM/yyyy",
                        value: "dd/MM/yyyy"
                    },
                    {
                        description: userDateFormat,
                        value: userDateFormat
                    }
                ]
            },
            'DATETIME': {
                defaultValue: advancedConfigs.dateTimeFormat || userDateTimeFormat,
                fieldDomains: [{
                        description: "dd/MM/yyyy HH:mm:ss",
                        value: "dd/MM/yyyy HH:mm:ss"
                    },
                    {
                        description: userDateTimeFormat,
                        value: userDateTimeFormat
                    },
                    {
                        description: "dd/MM/yyyy HH",
                        value: "dd/MM/yyyy HH"
                    },
                    {
                        description: "HH:mm",
                        value: "HH:mm"
                    }
                ]
            },

            'DOUBLE': numberFormatters,
            'INTEGER': numberFormatters
        };

        return options[type];
    },

    getTimeZoneValue: function (scheduleTimeZoneId) {
        return scheduleTimeZoneId ? {
                id: scheduleTimeZoneId
            } :
            Monet.Session.User.timeZone ||
            (Monet.Session.User.organization ? Monet.Session.User.organization.timeZone : null);
    },

    getImportTypeDomains: function () {
        return [{
                description: 'Greenmile.DataImport.TypeImportPatch',
                value: 'PATCH'
            },
            {
                description: 'Greenmile.DataImport.TypeImportOverWrite',
                value: 'OVERWRITE'
            },
            {
                description: 'Greenmile.DataImport.TypeImportSkipExists',
                value: 'SKIP_EXISTING'
            },
            {
                description: 'Greenmile.DataImport.TypeImportComplete',
                value: 'COMPLETE'
            }
        ];
    },

    getImportTypeDomainsByType: function (list, typeValue) {
        return list.filter(item => item.value === typeValue);
    }

};